import { render, staticRenderFns } from "./Katalinas.vue?vue&type=template&id=6c214edc"
import script from "./Katalinas.vue?vue&type=script&lang=js"
export * from "./Katalinas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports